import Model from '@/lib/data/Model';
// import Store from '@/store/store'
/* eslint-disable */
import User from './User';

class Representative extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        { name: 'shared', defaultValue: false, type: 'bool' },
        { name: 'is_owner', defaultValue: true, type: 'bool' },
        { name: 'is_code_changeable', defaultValue: true, type: 'bool' },
        { name: 'representative_mobile_id', type: 'int' },
        { name: 'tenant_id', type: 'int', defaultValue: 144 },
        { name: 'surveys_count', type: 'int', defaultValue: 0 },
        { name: 'record_state', type: 'int', defaultValue: 1 },
        {
            name: 'user',
            mapping: 'user_id',
            association: {
                type: 'one',
                model: User,
            },
        },
        'group_id',
        'organization_id',
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get isShared() {
        return this.shared;
    }

    get isActive() {
        return this.record_state == 1;
    }

    api = [
        {
            name: 'create',
            url: '/representative/save',
            associated: true,
        },
        {
            name: 'read',
            url: '/representative/read',
        },
        {
            name: 'update',
            url: '/representative/save',
            associated: true,
        },
        {
            name: 'delete',
            url: '/representative/delete',
            params: ['id'],
        },
        {
            name: 'assignSampleInspections',
            url: '/representative/assignSampleInspections',
            associated: true,
        },
    ];
}

export default Representative;
